import { Button } from '@/components/ui/button';
import { Sheet, SheetTrigger, SheetContent } from '@/components/ui/sheet';
import { MenuIcon } from 'lucide-react';
import { useMenu } from '@/context/MenuContext';
import { useState } from 'react';

export function MenuDrawer() {
  const [open, setOpen] = useState(false);
  const { listMenu, updateListMenu } = useMenu();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="secondary">
          <MenuIcon />
        </Button>
      </SheetTrigger>
      <SheetContent side="left">
        <div className="mt-6 mb-8">
          <span className="text-lg font-bold px-2">Menu</span>
        </div>
        <nav className="flex flex-col gap-1 px-2">
          {listMenu.map((item) => (
            <Button
              key={item.id}
              variant={item.active ? 'default' : 'outline'}
              className={`justify-start w-full ${item.active ? 'font-semibold' : ''}`}
              onClick={() => {
                updateListMenu(item.id);
                setOpen(false);
              }}
            >
              {item.name}
            </Button>
          ))}
        </nav>
      </SheetContent>
    </Sheet>
  );
}
